module.exports = __webpack_public_path__ + "static/media/undraw_forgot.24021047.svg";